import React from 'react';
import { motion } from 'framer-motion';
export function UseCases() {
  const cases = [{
    title: 'Eligibility and scheduling.',
    desc: 'Check coverage in real time, schedule appointments, and complete patient intake.'
  }, {
    title: 'Clinical documentation and ambient AI.',
    desc: 'Read and write structured notes, summaries, and billing codes directly from the EHR.'
  }, {
    title: 'Prior auth and billing automation.',
    desc: 'Run eligibility checks and submit prior authorizations to payers and clearinghouses.'
  }];
  return <section id="use-cases" className="py-24 relative z-10" data-id="element-220">
      <div className="max-w-7xl mx-auto px-6" data-id="element-221">
        <div className="mb-16" data-id="element-222">
          <span className="text-hubble-signal text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-223">
            USE CASES
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-paper mb-6" data-id="element-224">
            Built for the teams shaping healthcare AI.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-hubble-paper/70 max-w-3xl leading-[1.6]" data-id="element-225">
            From eligibility checks to clinical documentation, Hubble powers the
            agents working across healthcare.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-226">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-signal/30 transition-colors" data-id="element-227">
              <h3 className="font-heading text-xl font-medium text-hubble-paper mb-4" data-id="element-228">
                {item.title}
              </h3>
              <p className="font-body text-[16px] text-hubble-paper/70 leading-[1.6]" data-id="element-229">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}